import React from "react";

const GetInTouch = ({ heading, email }) => {
  return (
    <section className="studio-cta">
      <div className="studio-cta__inner">
        <h2 className="studio-cta__headline">
          Come build <em>with me</em>
        </h2>
        <a
          href={`mailto:${email}`}
          className="studio-cta__pill"
          aria-label={`Email ${email}`}
        >
          Say hi!
        </a>
      </div>
    </section>
  );
};

export default GetInTouch;
